module.exports = __webpack_public_path__ + "static/wpack/extracted/icon--world-corridor40bd76f32f39b174f98c32a6ddba9cea.png";